import { useChatboxStore } from "../../store";
import type { ToolResults } from "../../types";
import { UiNextMessage } from "../ui/UiNextMessage";
import type { MessagingMessage } from "@/model/messaging";

export const MessageFooter = ({ message }: { message: MessagingMessage }) => {
  const {
    use: { lastMessage, options },
    bind: { sendMessage },
  } = useChatboxStore();

  const customizedFooter = options?.bubble?.customizedFooter;
  const toolResults: ToolResults | undefined = message.payload.data
    ?.tool_results as ToolResults;
  const nextMsgs = toolResults?.next_messages ?? [];
  const showNextMessage = options?.bubble?.showNextMessage ?? true;
  const showCustomizedFooter = options?.bubble?.alwaysShowFooter ?? false;

  if (!showCustomizedFooter && message.uid !== lastMessage?.uid) {
    return null;
  }

  return (
    <>
      {customizedFooter?.(message)}
      {showNextMessage && (
        <UiNextMessage nextMsgs={nextMsgs} onSendMessage={sendMessage} />
      )}
    </>
  );
};
